import { render, staticRenderFns } from "./TotalSum.vue?vue&type=template&id=abd29b32&scoped=true&"
import script from "./TotalSum.vue?vue&type=script&lang=js&"
export * from "./TotalSum.vue?vue&type=script&lang=js&"
import style0 from "./TotalSum.vue?vue&type=style&index=0&id=abd29b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd29b32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
